/**
 * Format a number with thousand separators and decimal places
 * @param num - The number to format
 * @param decimals - Number of decimal places (default: 2)
 * @returns Formatted number string (e.g., 1,234.56)
 */
export const formatNumber = (num: number | null | undefined, decimals: number = 2): string => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0.00';
  }

  return num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
};

/**
 * Format a currency amount with thousand separators
 * @param amount - The amount to format
 * @param currency - The currency code (e.g., 'ILS', 'USD')
 * @returns Formatted currency string (e.g., 1,234.56 ILS)
 */
export const formatCurrency = (amount: number | null | undefined, currency: string): string => {
  const formattedNumber = formatNumber(amount);
  return `${formattedNumber} ${currency}`;
};
